<div class="header">
    <span class="title" trans>New Menu Item</span>
    <mat-icon svgIcon="close" (click)="closeClick.emit()"></mat-icon>
</div>
<div class="new-item-tabs">
    <mat-accordion>
        <form (ngSubmit)="addLinkMenuItem()" ngNativeValidate>
            <mat-expansion-panel class="mat-elevation-z" [expanded]="activePanel === 'link'">
                <mat-expansion-panel-header><mat-panel-title trans>Link</mat-panel-title></mat-expansion-panel-header>
                <div class="many-inputs">
                    <div class="input-container">
                        <label for="external-link-url" trans>URL</label>
                        <input type="url" id="external-link-url" name="external-link-url" [(ngModel)]="linkModel.url" required>
                    </div>
                    <div class="input-container">
                        <label for="external-link-text" trans>Link Text</label>
                        <input type="text" id="external-link-text" name="external-link-text" [(ngModel)]="linkModel.linkText" required>
                    </div>
                </div>
                <mat-action-row>
                    <button mat-button color="accent" type="submit" trans>Add</button>
                </mat-action-row>
            </mat-expansion-panel>
        </form>
        <mat-expansion-panel class="mat-elevation-z">
            <mat-expansion-panel-header><mat-panel-title trans>Route</mat-panel-title></mat-expansion-panel-header>
            <div class="items-list scroll-container" customScrollbar>
                <div class="item" *ngFor="let route of appearance.config.menus.availableRoutes"
                     (click)="addRouteMenuItem(route)">{{route}}
                </div>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mat-elevation-z">
            <mat-expansion-panel-header><mat-panel-title trans>Page</mat-panel-title></mat-expansion-panel-header>
            <div class="items-list">
                <div class="item" *ngFor="let page of allPages" (click)="addPageMenuItem(page)">{{page.slug}}</div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>